/**
 * Enum-like object containing all valid paths for the lessons API.
 * This helps maintain consistency and provides autocomplete support.
 * @readonly
 * @enum {string}
 */
export const LessonApiPath = Object.freeze({
  /** Start a new learning journey by collecting background info */
  INFO_GETTING: "InfoGettingAgent",

  /** Start the language assessment process */
  ASSESSMENT: "AssessmentAgent",

  /** Get the latest active course/lesson data */
  LATEST_COURSE: "LatestActiveCourse",
});
